import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import { Button, Col, Container, Row } from "react-bootstrap";
import ObonContact from "../ObonContact";
import { useTranslation } from "react-i18next";
const banerLogo = require("../../../Assets/Images/ObonLAndingPageImage/LandingPageImage.jpg");
const Contact = () => {
  const {t} = useTranslation();
  const textRef = useRef(null);
  const textRef2 = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline();
    const tl2 = gsap.timeline();

    tl.from(textRef.current, {
      duration: 0.7, // Animation duration (in seconds)
      opacity: 0, // Start with opacity 0
      y: 20, // Move text to the left
      ease: "power2.inOut", // Easing function for animation
    });
    tl2.from(textRef2.current, {
      duration: 0.7, // Animation duration (in seconds)
      opacity: 0, // Start with opacity 0
      y: 20, // Move text to the left
      ease: "power2.inOut", // Easing function for animation
    });
  }, []);

  return (
    <div id="Banner" style={{
      minHeight:"115vh",
    }}>
      <Container className="container-fluid text-reveal-container">
        <Row ref={textRef} className=" section " style={{
      minHeight:"100vh",
    }}>
          <Col
            md={12}
            className=" side d-flex justify-content-center align-items-center"
          >
            <div className="content" style={{
              display: "flex !important",
              justifyContent: "center",
              alignItems: "center !important" ,
            }}>
              <div >
                  <ObonContact />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
